import { onError } from '@apollo/client/link/error';

export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';

export const errorCatchLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (!graphQLErrors) {
    if (networkError) {
      console.log(`[Network error]: Error: ${networkError}`);
    }
    return forward(operation);
  }

  for (const err of graphQLErrors) {
    console.log(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`);
    switch (err?.extensions?.code) {
      case UNAUTHENTICATED: {
        const headers = operation.getContext().headers;
        operation.setContext({
          headers: {
            ...headers,
            authorization: '',
          },
        });
        return forward(operation);
      }
      case INTERNAL_SERVER_ERROR: {
        return forward(operation);
      }
      default:
        break;
    }
  }

  return forward(operation);
});
